import React from "react";
import { useParams } from "react-router-dom";
import useSmartBack from "../../hooks/useSmartBack";
import JobDescription from "./upload_jd";

/*
  AI Candidates (opened from the role view and workstation view pages).

  The role is already known, so there is no role picker: the JD (from the
  role's JD file, or built from the role's details and criteria) is sent
  through the same AI search as the Role Description tab as soon as the page
  opens. Candidates already mapped to the role are left out of the results.
*/
function SendRecommendedCandidates() {
  const { role_id } = useParams();
  const handleBack = useSmartBack(`/workstation/view/${role_id}`);

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h5 className="mb-0">AI Candidates</h5>
        <button
          className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
          onClick={handleBack}
        >
          <i className="ti ti-arrow-left me-2"></i>
          Back
        </button>
      </div>

      {/* key: switching to another role remounts and re-runs the search */}
      <JobDescription key={role_id} mode="role" roleId={role_id} />
    </div>
  );
}

export default SendRecommendedCandidates;
